<template>
	<div class="load-animation-container" >
		<section style="position: fixed; top: 30%;">
			<h2>Loading Your Content...</h2>
		<svg style="width:250px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			 viewBox="0 0 288 120" xml:space="preserve">
		<g>
			<g>
				<g>
					<path class="st0" d="M26.2,69.4v2.9H19V18.1h7.6v17.6c0.4-0.7,2.2-3.5,6.5-3.5c5.5,0,9.1,3.2,9.1,11.1v18.4
						c0,7.9-3.6,11.1-9.1,11.1C28.8,72.8,26.6,70.1,26.2,69.4z M34.5,60.1V45c0-4.1-1.3-5.8-4-5.8c-2.6,0-4,1.7-4,5.7v15.2
						c0,4.2,1.4,5.8,4,5.8C33.2,65.9,34.5,64.4,34.5,60.1z"/>
					<path class="st0" d="M44.9,61.7V43.5c0-7.9,3.6-11.1,9.1-11.1c4.3,0,6.6,2.7,7,3.4v-3h7.1v39.5h-7.1v-3c-0.4,0.7-2.7,3.5-7,3.5
						C48.6,72.8,44.9,69.7,44.9,61.7z M60.6,60.1V43.5c0-3-2-4.1-4-4.1c-2.6,0-4,1.5-4,5.8v14.9c0,4.3,1.4,5.7,4,5.7
						C59.3,65.8,60.6,64.3,60.6,60.1z"/>
					<path class="st0" d="M79.5,72.3h-7.6V32.8h7.2v3.1c0.4-0.7,2.6-3.5,6.9-3.5c5.5,0,9.1,3.2,9.1,11.1v28.8h-7.7V43.7
						c0-3.1-1.9-4.3-4-4.3s-4,1.2-4,4.1V72.3z"/>
					<path class="st0" d="M98,61.7V43.4c0-7.9,3.6-11.1,9.1-11.1c4.3,0,6.2,2.7,6.5,3.4V18.1h7.6v54.2h-7.1v-2.9
						c-0.4,0.7-2.7,3.4-7,3.4C101.6,72.8,98,69.7,98,61.7z M113.6,60.1V45c0-4.3-1.3-5.7-4-5.7c-2.5,0-4,1.6-4,5.8v15
						c0,4.3,1.4,5.8,4,5.8C112.3,65.9,113.6,64.4,113.6,60.1z"/>
					<path class="st0" d="M122.6,33.6h7.8l4.3,24.1l4.2-24.1h6.7l4.1,24.1l4.4-24.1h7.7l-7.9,38.7h-7.6l-4-23.8l-4,23.8h-7.5
						L122.6,33.6z"/>
					<path class="st0" d="M162.5,61.7V43.5c0-7.9,3.6-11.1,9.1-11.1c4.3,0,6.6,2.7,7,3.4v-3h7.1v39.5h-7.1v-3c-0.4,0.7-2.7,3.5-7,3.5
						C166.2,72.8,162.5,69.7,162.5,61.7z M178.2,60.1V43.5c0-3-2-4.1-4-4.1c-2.6,0-4,1.5-4,5.8v14.9c0,4.3,1.4,5.7,4,5.7
						C176.9,65.8,178.2,64.3,178.2,60.1z"/>
					<path class="st0" d="M197.1,72.3h-7.6V32.8h7.2v3.1c0.4-0.7,2.6-3.5,6.9-3.5c5.5,0,9.1,3.2,9.1,11.1v28.8H205V43.7
						c0-3.1-1.9-4.3-4-4.3c-2.1,0-4,1.2-4,4.1V72.3z"/>
				</g>
				<g>
					<path class="st1" d="M227.2,83.1c-2.1,0-4,1.2-4,4.3v1.4v0.2v2.2c0,3.1,1.9,4.3,4,4.3c2.1,0,4-1.2,4-4.3v-4.4v-2.1v-1.6
						L227.2,83.1L227.2,83.1z"/>
					<path class="st1" d="M231.2,46c0-5-1.1-6.7-4-6.7c-2.1,0-4,1.2-4,4.3V59c0,5,1.1,6.8,4,6.8c3,0,4-1.7,4-6.6V46z"/>
					<path class="st1" d="M253.7,66c2.1,0,4-1.2,4-4.3V43.5c0-3-1.8-4.3-4-4.3c-2.2,0-4,1.3-4,4.3v18.2C249.6,64.8,251.5,66,253.7,66z
						"/>
					<path class="st2" d="M253.7,72.9c7.3,0,11.6-4.7,11.6-12.3V44.5c0-7.4-4.3-12.1-11.6-12.1c-7.4,0-11.7,4.8-11.7,12.1v16.1
						C242,68.2,246.2,72.9,253.7,72.9z M249.6,43.5c0-3,1.8-4.3,4-4.3c2.1,0,4,1.3,4,4.3v18.2c0,3.1-1.9,4.3-4,4.3c-2.1,0-4-1.2-4-4.3
						V43.5z"/>
					<path class="st2" d="M269.4,79.7l-2.8-3.5h-27.8V32.8h-7.1v3c-0.5-0.8-3.1-3.3-7.3-3.3c-5.3,0-8.8,3.1-8.8,11v18.2
						c0,8,3.6,11.2,9.1,11.2c4.3,0,6.1-2.8,6.5-3.5v6.8h-4c-7.4,0-11.7,4.7-11.7,12.3v0.3v0.2v1.1c0,7.6,4.2,12.3,11.7,12.3
						c7.3,0,11.6-4.7,11.6-12.3v-5v-0.5v-1.6h27.8L269.4,79.7z M227.2,65.8c-2.9,0-4-1.8-4-6.8V43.6c0-3.1,1.8-4.3,4-4.3
						c2.9,0,4,1.7,4,6.7v13.2C231.2,64.1,230.2,65.8,227.2,65.8z M231.2,84.7v2.1v4.4c0,3.1-1.9,4.3-4,4.3c-2.1,0-4-1.2-4-4.3v-2.2
						v-0.2v-1.4c0-3.1,1.9-4.3,4-4.3v0h4V84.7z"/>
				</g>
			</g>
			<g>
				<path class="st0" d="M24.2,82.9h-2v12h-1.4v-12H19v-1.3h5.3V82.9z"/>
				<path class="st0" d="M26.8,95h-1.3V81.6h1.3v3.5c0.3-0.5,0.9-0.9,1.7-0.9c1.3,0,2.1,0.7,2.1,2.5V95h-1.3v-8.3
					c0-0.9-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.4-1.3,1.3V95z"/>
				<path class="st0" d="M32.2,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.3-0.5,1.3-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C33.2,95.1,32.2,94.1,32.2,92.4z M33.5,89.2H36v-2.3
					c0-1.1-0.5-1.6-1.3-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
				<path class="st0" d="M47.3,84.7v7.1c0,2.1-1.2,3.1-2.8,3.1h-2.7V81.6h2.7C46.2,81.6,47.3,82.7,47.3,84.7z M44.4,82.9h-1.2v10.8
					h1.2c0.9,0,1.6-0.5,1.6-1.9v-7.1C46,83.4,45.2,82.9,44.4,82.9z"/>
				<path class="st0" d="M49,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.3-0.5,1.3-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C49.9,95.1,49,94.1,49,92.4z M50.3,89.2h2.5v-2.3
					c0-1.1-0.5-1.6-1.3-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
				<path class="st0" d="M60.5,86.7h-1.3c0-0.9-0.5-1.3-1.2-1.3c-0.7,0-1.2,0.5-1.2,1.2c0,0.4,0.2,0.8,0.5,1.3l2.1,2.4
					c0.9,1.1,1.1,1.7,1.1,2.5c0,1.1-0.8,2.3-2.5,2.3c-1.6,0-2.6-0.9-2.6-2.5h1.3c0,0.9,0.5,1.3,1.3,1.3c0.8,0,1.2-0.6,1.2-1.2
					c0-0.5,0-0.8-0.6-1.5l-2.1-2.4c-0.8-0.9-1-1.7-1-2.3c0-1.2,0.9-2.3,2.4-2.3C59.6,84.2,60.5,85.1,60.5,86.7z"/>
				<path class="st0" d="M61.4,84.4c0.8,0,1.1-0.3,1.1-1.7h0.9v1.6H65v1.2h-1.6v7.1c0,1,0.4,1.3,1.3,1.3c0.1,0,0.3,0,0.3,0V95
					c0,0-0.3,0-0.6,0c-1.9,0-2.3-0.9-2.3-2.6v-7h-0.7V84.4z"/>
				<path class="st0" d="M67.1,83.3c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8
					C67.9,82.9,67.5,83.3,67.1,83.3z M67.7,95h-1.3V84.4h1.3V95z"/>
				<path class="st0" d="M70.8,95h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9c1.3,0,2.2,0.8,2.2,2.5V95h-1.3v-8.3
					c0-0.9-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3V95z"/>
				<path class="st0" d="M76.2,92.6v-5.8c0-1.7,0.8-2.5,2.2-2.5c0.9,0,1.5,0.5,1.7,0.9v-0.7h1.2V95h-1.2v-0.7
					c-0.2,0.3-0.8,0.9-1.7,0.9C77.1,95.1,76.2,94.3,76.2,92.6z M80,92.6v-6c0-0.9-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3v5.9
					c0,0.9,0.5,1.3,1.3,1.3C79.5,94,80,93.5,80,92.6z"/>
				<path class="st0" d="M82.5,84.4c0.8,0,1.1-0.3,1.1-1.7h0.9v1.6H86v1.2h-1.6v7.1c0,1,0.4,1.3,1.3,1.3c0.1,0,0.3,0,0.3,0V95
					c0,0-0.3,0-0.6,0c-1.9,0-2.3-0.9-2.3-2.6v-7h-0.7V84.4z"/>
				<path class="st0" d="M88.1,83.3c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8
					C88.9,82.9,88.6,83.3,88.1,83.3z M88.8,95h-1.3V84.4h1.3V95z"/>
				<path class="st0" d="M90.4,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.6,0,2.5,1,2.5,2.7v5.5c0,1.7-0.9,2.7-2.5,2.7
					C91.4,95.1,90.4,94.1,90.4,92.4z M94.2,92.6v-5.8c0-0.9-0.5-1.3-1.2-1.3c-0.8,0-1.3,0.5-1.3,1.3v5.8c0,0.9,0.5,1.3,1.3,1.3
					C93.7,93.9,94.2,93.5,94.2,92.6z"/>
				<path class="st0" d="M98.5,95h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9c1.3,0,2.2,0.8,2.2,2.5V95h-1.3v-8.3
					c0-0.9-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3V95z"/>
				<path class="st0" d="M111.6,82.9h-3.4v4.6h2.5v1.2h-2.5v4.9h3.4V95h-4.7V81.6h4.7V82.9z"/>
				<path class="st0" d="M117.2,95l-1.5-4.1l-1.5,4.1h-1.4l2.2-5.5l-2.1-5.2h1.4l1.4,3.8l1.4-3.8h1.4l-2.1,5.2l2.2,5.5H117.2z"/>
				<path class="st0" d="M125,86.8v5.8c0,1.7-0.8,2.5-2.2,2.5c-1,0-1.5-0.5-1.6-0.9v4.3h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9
					C124.2,84.3,125,85.1,125,86.8z M121.2,86.7v5.9c0,0.9,0.5,1.3,1.2,1.3c0.8,0,1.3-0.5,1.3-1.3v-5.9c0-0.9-0.5-1.3-1.3-1.3
					C121.7,85.4,121.2,85.8,121.2,86.7z"/>
				<path class="st0" d="M126.6,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.3-0.5,1.3-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C127.5,95.1,126.6,94.1,126.6,92.4z M127.9,89.2h2.5v-2.3
					c0-1.1-0.5-1.6-1.3-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
				<path class="st0" d="M136.6,85.5c0,0-0.1,0-0.2,0c-1.1,0-1.6,0.6-1.6,1.7V95h-1.3V84.4h1.2v0.8c0.2-0.3,0.6-0.9,1.7-0.9
					c0.1,0,0.2,0,0.2,0V85.5z"/>
				<path class="st0" d="M138.7,83.3c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8
					C139.5,82.9,139.1,83.3,138.7,83.3z M139.3,95H138V84.4h1.3V95z"/>
				<path class="st0" d="M140.9,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.2-0.5,1.2-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C141.9,95.1,140.9,94.1,140.9,92.4z M142.2,89.2h2.5v-2.3
					c0-1.1-0.5-1.6-1.2-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
				<path class="st0" d="M149,95h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9c1.3,0,2.2,0.8,2.2,2.5V95h-1.3v-8.3
					c0-0.9-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3V95z"/>
				<path class="st0" d="M159.6,92.4c0,1.7-0.9,2.7-2.5,2.7c-1.6,0-2.6-1-2.6-2.7v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.6,0,2.5,1,2.5,2.7V87
					h-1.3v-0.3c0-0.9-0.5-1.3-1.2-1.3c-0.8,0-1.3,0.5-1.3,1.3v5.8c0,0.9,0.5,1.3,1.3,1.3c0.7,0,1.2-0.4,1.2-1.3v-0.2L159.6,92.4
					L159.6,92.4z"/>
				<path class="st0" d="M161,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.2-0.5,1.2-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C161.9,95.1,161,94.1,161,92.4z M162.3,89.2h2.5v-2.3
					c0-1.1-0.5-1.6-1.2-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
				<path class="st0" d="M175.3,82.9h-3.4v4.6h2.5v1.2h-2.5v4.9h3.4V95h-4.7V81.6h4.7V82.9z"/>
				<path class="st0" d="M177.9,95h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9c1.3,0,2.2,0.8,2.2,2.5V95h-1.3v-8.3
					c0-0.9-0.6-1.3-1.3-1.3c-0.7,0-1.2,0.5-1.2,1.3V95z"/>
				<path class="st0" d="M187.1,94.2c-0.2,0.3-0.7,0.9-1.6,0.9c-1.3,0-2.2-0.8-2.2-2.5v-5.8c0-1.6,0.8-2.5,2-2.5
					c0.9,0,1.6,0.4,1.8,0.8v-0.7h1.2V96c0,1.6-0.5,2.6-2.5,2.6c-2,0-2.5-1.1-2.5-2.2h1.3c0,0.6,0.4,1.1,1.2,1.1c0.9,0,1.2-0.4,1.2-1.3
					V94.2z M184.6,92.2c0,1.2,0.4,1.7,1.3,1.7c0.9,0,1.2-0.5,1.2-1.7V87c0-1.2-0.4-1.7-1.2-1.7c-0.7,0-1.3,0.5-1.3,1.3V92.2z"/>
				<path class="st0" d="M190.9,83.3c-0.5,0-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8
					C191.7,82.9,191.3,83.3,190.9,83.3z M191.5,95h-1.3V84.4h1.3V95z"/>
				<path class="st0" d="M194.6,95h-1.3V84.4h1.2v0.8c0.2-0.3,0.8-0.9,1.7-0.9c1.3,0,2.2,0.8,2.2,2.5V95h-1.3v-8.3
					c0-0.9-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3V95z"/>
				<path class="st0" d="M200.1,92.4v-5.5c0-1.6,0.9-2.7,2.6-2.7c1.8,0,2.5,1.1,2.5,3v2.9h-3.8v2.5c0,0.8,0.6,1.3,1.3,1.3
					c0.7,0,1.2-0.5,1.2-1.2v-0.1h1.3v0.1c0,1.3-0.9,2.3-2.5,2.3C201,95.1,200.1,94.1,200.1,92.4z M201.4,89.2h2.5v-2.3
					c0-1.1-0.5-1.6-1.2-1.6c-0.7,0-1.3,0.5-1.3,1.4V89.2z"/>
			</g>
		</g>
		</svg>
		</section>
	</div>

</template>

<script>
export default {
	data() {
		return {
			name:'loadAnimation'
		}
	}
}
</script>

<style scoped>

.st0 {
	fill:transparent; 
	stroke: #414042;
  	stroke-dasharray: 1000;
  	stroke-dashoffset: 1000;
  	animation: dash 4s linear infinite;
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  25% {
	  fill:#414042;
  }
  100% {
	stroke-dashoffset: 0;
	fill:#414042
  }
}

@keyframes dashGreen {
  0% {
    stroke-dashoffset: 1000;
  }
  50% {
	  fill:#80BC00;
  }
  100% {
	stroke-dashoffset: 0;
	fill:#80BC00
  }
}

/* .st0{fill:#414042;} */
.st1{fill:none;}
.st2 {
	fill:transparent; 
	stroke: #80BC00;
  	stroke-dasharray: 1000;
  	stroke-dashoffset: 1000;
  	animation: dashGreen 4s linear infinite;
}

.load-animation-container {
	background: white;
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 200;
    left: 0;
    display: flex;
    align-items: center;
	justify-content: center;
	flex-direction: column;
	top: 0;
}

</style>